import { useStore } from '../js/store';
import AppService, { LocalStorageService, Utilities } from "s2s-app-service";
import ObjectMerge from 'object-merge';
import useAlerts from '../hooks/alerts';
import {
  processServiceErrorsToAlerts,
  pathOr,
} from '../js/utilities';

const initialState = { "isAuthorized": false, "authPending": false, "auth": undefined};

const useAuth = () => {
  const [state, setState] = useStore();
  const [, { createErrorAlert }] = useAlerts();
  // console.log('constructor for auth >>>>>>', state);

  const setIsOnline = (isOnline = false) => {
    return setState(old => {
      const newState = { ...old };
      newState.auth.isOnline = isOnline;
      return newState;
    });
  };

  const setAuth = (authData) => {

    return setState(old => {
      const newState = ObjectMerge({}, old);
      newState.auth = newState !== undefined && newState.auth ? newState.auth : initialState;
      newState.auth = ObjectMerge({}, newState.auth, { "isAuthorized": true, "authPending": false, "auth": authData });
      return newState;
    });
  };

  const login = async (email, password) => {
    let authData;

    try {
      authData = await AppService.getInstance().login({ email, password });

      if (typeof authData.telephony_data.reason !== "undefined" && typeof authData.telephony_data.code !== "undefined" &&
          (['401', '404'].indexOf(authData.telephony_data.code) > -1 ||
          ['expiring', 'expired'].indexOf(authData.telephony_data.reason) > -1)) {
        const errorObject = {
          code: authData.telephony_data.code,
          message: 'Login Error',
          details: [`Something went wrong with login. Specifically, your password is: ${authData.telephony_data.reason}`],
        };

        throw errorObject;
      }

      setAuth(authData);
    } catch (e) {
      const errorObject = {
        code: 401,
        message: 'Login Error',
        details: [e.message],
      };

      throw errorObject;
    }
  };

  const forgot = (email) => {
    try {
      return AppService.getInstance().accountHelper({ "action": "generate", "email": email });
    } catch (e) {
      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(Utilities.formatError(e));

      createErrorAlert({
        message,
        details: [alertBody],
        autoCloseTimeout: 10,
      });
    }

  };

  const logout = () => {  
    try {
      const username = pathOr(undefined, ['auth', 'auth', 'access_tokens', 'apiv5', 'userName'], state);
      LocalStorageService.setData('lastUser', { username });
      // Need to disconnect to de-register the phone
      AppService.getInstance().logout();
      const myStateAuth = state !== undefined && state.auth ? state.auth : initialState;
      return setState(old => ({
        ...old,
        auth: {
          ...myStateAuth,
          "isAuthorized": false,
          "authPending": false,
          "auth": undefined,
          "isOnline": false,
        },
      }));
    } catch (e) {
      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(Utilities.formatError(e));

      createErrorAlert({
        message,
        details: [alertBody],
        autoCloseTimeout: 10,
      });
    }
  };

  const updateIdentity = async () => { 
    try {
     if(typeof state.auth !== "undefined" && state.auth.isOnline){
      const identityData = await AppService.getInstance().speak("getIdentityDetails", {});
      return setState(old => {
        const newState = ObjectMerge({}, old);
        if (typeof newState.auth !== "undefined" && typeof newState.auth.auth !== "undefined" && typeof newState.auth.auth.identity !== "undefined") {
          newState.auth.auth.identity = ObjectMerge({}, identityData);
        } else {
          const errorObject = {
            message: 'Update Identity Error',
            details: ['State is missing auth auth identity'],
          };

          throw errorObject;
        }
        return newState;
      });
     }    
    } catch (e) {
      console.warn('UNABLE TO UPDATE IDENTITY', e);
    }
  };

  const aReturn = state !== undefined && typeof state.auth !== "undefined" ? state.auth : initialState;

  return [aReturn, { setAuth, login, logout, forgot, updateIdentity, setIsOnline}];
};

export default useAuth;
export { initialState };